import GoogleTagManager from '@redux-beacon/google-tag-manager';

export const gtm = GoogleTagManager();
